import { GET_ELECTRONIC_DOCS, FINANCIAL_PROCESS } from "..";
import { apiInstance } from "../config/apiInstance";

export const putFinancialProcess = async (
  id: string,
  isFinancialProcess: boolean,
) => {
  return await apiInstance.put(
    `${GET_ELECTRONIC_DOCS}/${id}${FINANCIAL_PROCESS}`,
    { isFinancialProcess },
  );
};
